export const TRANSLATIONS_FR = {
  All: "Tous",
  Dry: "Sec",
  Dryingout: "Séchage",
  Healthy: "En bonne santé",
  Manual: "Manuel",
  Menu: "Menu",
  Midphase: "Phase de maturité",
  Oldphase: "Phase de vieillissement",
  Profile: "Profil",
  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Définir le rapport du projet à l'aide de l'épingle",
  Unknown: "Inconnu",
  Wet: "Mouillé",
  Youngphase: "Phase jeunesse",
  account_type: "Type de compte",
  action: "Action",
  action_priority: "Priorité des actions",
  action_required: "Action requise",
  actions: "Actes",
  active: "actif",
  active_installation: "Installation active",
  active_sensor_installation: "Installation du capteur actif",
  add: "Ajouter",
  addTree: "Ajouter un arbre",
  add_all_form: {
    area: {
      existing_area: "Choisissez une zone existante",
      explanation:
        "Voulez-vous ajouter l'Arbre à une Zone existante ou souhaitez-vous créer une Zone et y ajouter l'Arbre ?",
      new_area: "Créer une nouvelle zone",
      title: "Zone",
    },
    no_photos: "Aucune photo téléchargée",
    sensor: {
      existing_sensors: "Choisissez des capteurs existants",
      explanation:
        "Voulez-vous qu'un capteur ajoute un arbre existant ou souhaitez-vous en créer un nouveau ?",
      new_sensor: "Ajouter un nouveau capteur",
      title: "Capteur",
    },
    title: "Ajouter un arbre avec un capteur dans la zone",
    traffic_safety: "Sécurité",
    tree: {
      existing_tree: "Choisissez un arbre existant",
      explanation:
        "Souhaitez-vous ajouter un arbre existant ou souhaitez-vous en créer un nouveau ? Ici, vous pouvez utiliser un nouveau capteur et le Baum hinzugefügt werden. Afin d'avoir un meilleur capteur, vous pouvez l'utiliser pour le faire fonctionner.",
      new_tree: "Créer un nouvel arbre",
      title: "Arbre",
    },
    tree_info: "Informations sur l'arbre",
  },
  add_area: "Ajouter une zone",
  add_assessment: "Ajouter une évaluation",
  add_child_tree: "Ajouter un arbre enfant",
  add_comment: "Ajouter un commentaire",
  add_existing_tree: "Ajouter une arborescence existante",
  add_inspection: "Ajouter une inspection",
  add_installation: "Ajouter une installation",
  add_photo: "Ajouter une photo",
  add_safety_assessment: "Ajouter une évaluation de sécurité",
  add_sensor: "Ajouter un capteur",
  add_task: "Ajouter une tâche",
  add_tree_img: "Ajouter une image d'arborescence",
  add_user: "Ajouter un utilisateur",
  add_vta: "Ajouter une évaluation VTA",
  add_your_own_maintenance: "Ajoutez votre propre maintenance",
  address: "Adresse",
  adjust_thresholds_crown: "Ajuster les seuils pour les capteurs de couronne",
  adjust_thresholds_soil: "Ajuster les seuils pour les capteurs de sol",
  admin: "Administrateur",
  aim: "Objectif du projet",
  aim_irrigation_demand_determination: "Détermination de la demande d'irrigation",
  alerts: "Alertes",
  align_qr_code_within_the_frame: "Alignez le code QR dans le cadre",
  all_areas: "Tous les domaines",
  all_projects: "Tous les projets",
  all_responsible: "Tous responsables",
  all_species: "Toutes les espèces",
  all_trees: "Tous les arbres",
  already_have_an_account: "Vous avez déjà un compte ?",
  altitude: "Altitude",
  amount_nodes: "Nœuds de capteur de quantité",
  api_documentation: "Documentation API",
  appearance: "Apparence",
  area: "Zone",
  areaName: "Nom",
  area_form: {
    existing_area: "Zone existante",
  },
  area_management: "Gestion de zone",
  areas: "Domaines",
  assessment_date: "Date d'évaluation",
  assessor: "Assesseur",
  assign_to_tree: "Attribuer à l'arborescence",
  back: "Dos",
  back_to_login: "Retour à la connexion",
  activate_account: "Activer le compte",
  activating_account: "Activation du compte en cours...",
  activation_success: "Compte activé avec succès !",
  activation_success_message:
    "Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter.",
  activation_failed: "Échec de l'activation",
  bark_condition: {
    healthy: "En bonne santé",
    minor_damage: "Dommages mineurs",
    moderate_damage: "Dégâts modérés",
    severe_damage: "Dommages graves",
  },
  bark_condition_label: "État de l'écorce",
  basic: "Basique",
  basic_user_areas_hint:
    "Les utilisateurs de base doivent se voir attribuer une ou plusieurs zones/emplacements. Sans missions, leurs données accessibles sont limitées.",
  basic_user_projects_hint:
    "Vous pouvez attribuer des projets complets ici. Tous les emplacements/zones appartenant aux projets sélectionnés seront inclus.",
  battery: "Batterie",
  battery_empty: "Batterie vide",
  battery_full: "Batterie pleine",
  battery_is_getting_low: "La batterie devient faible",
  beta_ended: {
    description:
      "Merci d'utiliser la version bêta ! Tous les changements et améliorations de la phase bêta ont été mis en œuvre et sont désormais disponibles dans TreeSense Cloud.",
    link_text: "Accédez à TreeSense Cloud",
    subtitle: "La phase de test est terminée",
    title: "Phase bêta terminée",
  },
  button: {
    add_all: "Ajouter une arborescence avec des composants",
    add_customer: "Ajouter un client",
    add_irrigation_area: "Ajouter une zone d'irrigation",
    add_sensor: "Ajouter un capteur",
    add_tree: "Ajouter un arbre",
    back: "Dos",
    cancel: "Annuler",
    edit_customer: "Modifier le client",
    import_tree: "Importer l'arborescence",
    next: "Suivant",
    reset: "Réinitialiser",
    save: "Sauvegarder",
    saving: "Sauvegarde...",
    update: "Mise à jour",
    updating: "Mise à jour...",
  },
  calculated_values_wip:
    "Les valeurs calculées (moisture_content, resis_temp_comp) sont toujours en cours de travail. Veuillez les utiliser avec prudence. Veuillez sélectionner si vous souhaitez également télécharger les valeurs calculées.",
  calibration_species: "Espèces d'étalonnage",
  calibration_species_legacy_settings_hint: "L'ancien calibrage du peuplier noir est utilisé.",
  calibration_species_no_mapping: "Aucune cartographie des espèces disponible",
  calibration_species_settings_hint:
    "Si aucun mappage n'est affiché ici ou si la formule héritée est toujours active, celle-ci peut être mise à jour sous Paramètres > Client > Formule de teneur en humidité.",
  calibration_species_settings_link: "Ouvrir les paramètres",
  calibration_species_tooltip:
    "Le modèle d'étalonnage utilisé pour cette espèce pour calculer l'indice d'humidité",
  calibration_species_unknown_tree_species: "Espèces d'arbres manquantes",
  cancel: "Annuler",
  optional: "facultatif",
  export_irrigation_tasks: "Exporter les tâches d'irrigation",
  export_irrigation_tasks_short: "Exporter",
  export_irrigation_tasks_description_v2:
    "Exporter le plan d'irrigation vers Excel pour un responsable spécifique. Affiche toutes les irrigations de la saison de végétation en cours (avril - octobre).",
  export_filter_assignee_hint: "Laisser vide pour exporter les tâches de tous les responsables",
  no_irrigation_tasks_found:
    "Aucune tâche d'irrigation trouvée pour les filtres sélectionnés. Veuillez vérifier le responsable et la période.",
  tree_number: "N° d'arbre",
  sensor_installed: "Capteur installé",
  responsible_person: "Responsable",
  irrigation_abbrev: "Irrig.",
  irrigation_plan: "Plan d'irrigation",
  represented_trees: "Arbres à irriguer conjointement",
  card_name: "Nom de la carte",
  card_number: "Numéro de carte",
  care_chat: {
    action_required: "Action requise",
    add_entry: "Ajouter une entrée",
    add_photo: "Ajouter une photo",
    all_priorities: "Toutes les priorités",
    all_statuses: "Tous les statuts",
    all_types: "Tous types",
    amount: "Montant:",
    appointment_label: "Rendez-vous:",
    assignment: "Affectation",
    assignment_display: "Affectation:",
    attachment_display: "Pièce jointe:",
    back: "Dos",
    cancel: "Annuler",
    completion: "Achèvement",
    consult_specialist: "Consultation avec un service spécialisé",
    cost_center: "Centre de coûts",
    cost_center_display: "Centre de coûts :",
    cut_type: "Type de coupe :",
    date: "Date",
    datetime: "Date et heure",
    datetime_display: "Date/Heure :",
    deadline: "Date limite:",
    delete: "Supprimer",
    description: "Description",
    description_display: "Description:",
    detailed_investigation: "Enquêtes détaillées",
    edit: "Modifier",
    executor: "Exécuteur:",
    favorite: "Préféré",
    felling: "Abattage",
    fill_checklist: "Remplir la liste de contrôle",
    fill_form: "Remplissez le formulaire",
    fill_protocol: "Remplir le protocole",
    finding: "Constatation :",
    follow_up_inspection: "Inspection régulière (suivi)",
    further_action_title: "Action supplémentaire",
    future_date_required: "Veuillez choisir une date et une heure futures.",
    immediately: "immédiatement",
    in_days: "In {{days}} days",
    in_hours: "In {{hours}} hrs.",
    in_one_month: "Dans un mois",
    in_one_week: "Dans une semaine",
    inspected_by: "Inspecté par",
    inspected_by_display: "Inspecté par :",
    inspection_data: "Données d'inspection",
    inspection_date_display: "Date de contrôle :",
    inspection_intervals: "Intervalles de contrôle",
    inspection_level: "Niveau de contrôle :",
    inspection_title: "Documenter l’inspection régulière",
    interval_as_before: "comme avant",
    interval_display: "Intervalle:",
    interval_future_every: "à l'avenir chaque",
    interval_years: "Intervalle (années)",
    interval_years_annual: "années / annuellement",
    irrigation_log_title: "Protocole d'irrigation",
    irrigation_method: "Méthode d'irrigation",
    irrigation_method_display: "Méthode d'arrosage :",
    irrigation_method_placeholder: "par ex. manuel, sac d'arrosage, citerne",
    irrigation_protocol_title: "Remplir le protocole d'irrigation",
    mark_done: "Marquer comme terminé",
    mark_not_done: "Marquer comme non terminé",
    measure_free: "Entrée gratuite",
    measure_inspection: "Inspection régulière",
    measure_irrigation: "Irrigation",
    measure_pruning: "Mesure d'élagage",
    method: "Méthode:",
    next_inspection: "Prochaine inspection",
    next_inspection_display: "Prochain contrôle :",
    next_inspection_label: "Prochain contrôle :",
    no: "Non",
    no_entries_found: "Aucune entrée trouvée.",
    no_inspection_planned: "Aucune inspection prévue.",
    no_tasks_found: "Aucune tâche trouvée.",
    overdue_since_days: "Overdue for {{days}} days",
    overdue_since_hours: "Overdue for {{hours}} hrs.",
    perform_inspection: "Effectuer une inspection",
    plan_inspection: "Contrôle des plans",
    please_provide_tree_condition: "Veuillez indiquer l'état de l'arbre.",
    please_provide_type: "Veuillez fournir un type.",
    please_select_person: "Veuillez sélectionner une personne.",
    priority: "Priorité",
    priority_critical: "Critique",
    priority_high: "Haut",
    priority_low: "Faible",
    priority_medium: "Moyen",
    pruning_clearing: "Débroussaillage / débroussaillement",
    pruning_crown_reduction: "Réduction de la couronne / soin de la couronne",
    pruning_formative: "Taille de formation",
    pruning_log_title: "Protocole de taille",
    pruning_maintenance: "Taille d'entretien",
    pruning_protocol_title: "Protocole de taille de remplissage",
    pruning_remedial: "Taille de rattrapage (réparatrice/correctrice)",
    pruning_safety: "Taille de sécurité (élagage de sécurité routière)",
    pruning_type: "Type de mesure de taille",
    pruning_type_display: "Taper:",
    pruning_type_required: "Type de mesure de taille (obligatoire)",
    reason: "Raison / occasion",
    reason_display: "Raison:",
    reason_label: "Raison/occasion :",
    reason_placeholder: "régulier, sécheresse, ...",
    recommendation: "Recommandation:",
    remark_display: "Remarque:",
    remark_optional: "Remarque (facultatif)",
    remarks: "Remarques",
    remarks_display: "Remarques :",
    remarks_label: "Remarques",
    remove: "Retirer",
    reschedule: "Reprogrammer",
    reschedule_title: "Reprogrammer un rendez-vous",
    responsible_person: "Personne responsable",
    responsible_person_display: "Personne responsable :",
    responsible_person_required: "Personne responsable (obligatoire)",
    road_safe: "Sécurité routière",
    road_safe_display: "Sécurité routière :",
    save: "Sauvegarder",
    scope: "Portée:",
    select_placeholder: "Sélectionner",
    sensor_install_task: "Monter le capteur sur un arbre",
    sensor_maintenance_task: "Effectuer la maintenance du capteur sur l'arbre",
    short_description_optional: "Brève description (facultatif)",
    short_description_placeholder: "Brève description",
    show_less: "Afficher moins",
    show_more: "Afficher plus",
    soil_dry: "sec",
    soil_moisture: "Humidité du sol",
    soil_moisture_display: "Humidité du sol :",
    soil_slightly_moist: "légèrement humide",
    soil_wet: "mouillé",
    sort_by_date: "Trier par date",
    sort_by_priority: "Trier par priorité",
    status_commissioned: "Commandé",
    status_done: "Fait",
    status_in_progress: "En cours",
    status_not_done: "Pas fait",
    status_planned: "Prévu",
    time: "Temps",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    tree_care_measures: "Mesures d'entretien des arbres",
    tree_care_measures_hint:
      "par ex. enlèvement du bois mort, taille de dégagement, stabilisation de la couronne",
    tree_condition: "État de l'arbre",
    tree_condition_damage: "dommage",
    tree_condition_display: "État de l'arbre :",
    tree_condition_healthy: "en bonne santé",
    tree_condition_other: "autre",
    tree_condition_placeholder: "par ex. sain, dommage, infection fongique",
    tree_condition_required: "État de l'arbre (obligatoire)",
    tree_condition_tilt: "inclinaison",
    tree_condition_wilted_leaves: "feuilles fanées",
    upload_document: "Télécharger un document",
    upload_document_hint:
      "Déposez un PDF, une image ou un document ici, ou cliquez pour sélectionner",
    water_amount_display: "Quantité d'eau :",
    water_amount_liters: "Quantité d'eau (litres)",
    water_amount_required: "Veuillez entrer la quantité d'eau.",
    weather_cloudy: "nuageux",
    weather_conditions: "Conditions météorologiques",
    weather_display: "Conditions météorologiques :",
    weather_dry: "sec",
    weather_rain_after: "pluie après",
    weather_rain_before: "il pleut avant",
    weather_sunny: "ensoleillé",
    weather_windy: "venteux",
    weeks: "semaines",
    within: "dans",
    yes: "Oui",
  },
  challenges: "Problèmes pendant le projet / Défis futurs",
  challenges_placeholder: "Quels problèmes sont survenus ? De quoi le client avait-il besoin ?",
  change: "Changement",
  change_image: "Changer l'image",
  change_language: "Changer de langue",
  change_logo: "Changer de logo",
  change_position: "Changer de position",
  characters: "Personnages",
  childTree: "Arbre enfant",
  child_trees: "Arbres enfants",
  choose_file: "Choisir un fichier",
  choose_location: "Choisir un emplacement",
  choose_project: "Choisissez un projet",
  choose_qr_to_scan: "Choisissez QR à numériser",
  choose_the_file_to_be_imported: "Choisissez le fichier à importer",
  choose_tree: "Choisir un arbre",
  city: "Ville",
  clear: "Clair",
  clear_filter: "Effacer le filtre",
  clearance_profile_pruning: "Taille du profil de dégagement",
  click_on_marker_to_select_tree: "Cliquez sur le marqueur pour sélectionner l'arbre",
  cloase_area_list: "Fermer la liste des zones",
  close: "Fermer",
  close_areas_list: "Fermer la liste des zones",
  close_overlays: "Fermer les superpositions",
  close_sidebar: "Fermer la barre latérale",
  close_time_controls: "Fermer les contrôles horaires",
  completed: "Complété",
  condition_reports: "Rapports de condition",
  confirm: "Confirmer",
  confirm_delete: "Confirmer la suppression",
  confirm_delete_image: "Êtes-vous sûr de vouloir supprimer cette image ?",
  confirm_delete_task_message: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
  continue: "Continuer",
  cookie_consent: {
    accept_all: "Accepter tout",
    accept_essential: "Essentiel uniquement",
    analytics_cookies: "Cookies d'analyse",
    analytics_cookies_description:
      "Ces cookies nous permettent de compter les visites et les sources de trafic afin de pouvoir mesurer et améliorer les performances de notre site Internet. Ils nous aident à comprendre quelles pages sont les plus populaires et comment les visiteurs se déplacent sur le site.",
    banner_description:
      "Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site Internet. Vous pouvez personnaliser vos préférences ou accepter tous les cookies.",
    banner_title: "Paramètres des cookies",
    cookie_policy: "Politique en matière de cookies",
    customize: "Personnaliser",
    essential_cookies: "Cookies essentiels",
    essential_cookies_description:
      "Ces cookies sont essentiels au fonctionnement du site Web et ne peuvent pas être désactivés. Ils ne sont généralement définis qu'en réponse aux actions que vous effectuez, telles que la définition de vos préférences de confidentialité, la connexion ou le remplissage de formulaires.",
    last_updated: "Dernière mise à jour",
    marketing_cookies: "Cookies marketing",
    marketing_cookies_description:
      "Ces cookies peuvent être définis par nos partenaires publicitaires via notre site Web. Ils peuvent être utilisés pour établir un profil de vos intérêts et vous montrer des publicités pertinentes sur d’autres sites Web.",
    preferences_cookies: "Cookies de préférence",
    preferences_cookies_description:
      "Ces cookies permettent au site Web de mémoriser vos choix (tels que votre nom d'utilisateur, votre langue ou votre région) et de fournir des fonctionnalités améliorées et plus personnalisées.",
    preferences_error: "Erreur lors de l'enregistrement des préférences.",
    preferences_saved: "Vos préférences en matière de cookies ont été enregistrées.",
    privacy_policy: "politique de confidentialité",
    save_preferences: "Enregistrer les préférences",
    settings_description:
      "Gérez vos préférences en matière de cookies. Les modifications prendront effet immédiatement.",
    settings_title: "Paramètres des cookies",
  },
  cost_analysis: "Analyse des coûts",
  country: "Pays",
  create_account: "Créer un compte",
  create_customer: "Créer un client",
  create_new_tree: "Créer un nouvel arbre",
  create_task: "Créer une tâche",
  creating: "créer",
  critical: "Critique",
  critical_sensors: "Nombre total de capteurs critiques",
  crown: "Couronne",
  crown_care: "Soins de la couronne",
  crown_defects: "Défauts de la couronne",
  crown_diameter: "Diamètre de la couronne",
  crown_vitality: "Vitalité de la couronne",
  current_theme: "Thème actuel",
  custom_maintenance_type: "Type de maintenance personnalisé",
  custom_range: "Gamme",
  custom_range_info: "Sélectionnez une plage de dates et d'heures personnalisée",
  customer: "Client",
  customer_attributes: "Attributs du client",
  customer_creation_code: "Code de création client",
  customer_name: "Nom du client",
  customer_statistics_description: "Afficher les statistiques client et l'aperçu des données",
  customer_type: "Type de client",
  customer_type_agriculture: "Agriculture",
  customer_type_city: "Ville",
  customer_type_forestry: "Sylviculture",
  customer_type_science: "Science",
  customers: "Clients",
  daily_changes_email: "E-mail des changements quotidiens",
  damage_severity: {
    critical: "Critique",
    light: "Lumière",
    moderate: "Modéré",
    none: "Aucun",
    severe: "Grave",
  },
  damage_severity_label: "Gravité des dommages",
  dashboard: {
    all_locations: "Tous les emplacements",
    avg_age: "Âge moyen des arbres",
    avg_crown_diameter: "Diamètre moyen de la couronne",
    avg_height: "Hauteur moyenne des arbres",
    avg_trunk_diameter: "Diamètre moyen du tronc",
    data_status: "Statut des données",
    greeting: "Bonjour",
    group_biometrics: "Biométrie des arbres",
    group_inventory: "Inventaire des arbres",
    group_recommendations: "Recommandations",
    group_sensors: "État du capteur",
    health_last_30_days: "Santé 30 derniers jours",
    health_overview: "Aperçu",
    kpi_avg_age: "Âge moyen",
    kpi_avg_crown_diameter: "Diamètre moyen de la couronne",
    kpi_avg_height: "Taille moyenne",
    kpi_avg_trunk_circumference: "Circonférence moyenne du tronc",
    kpi_critical_sensors: "Capteurs critiques",
    kpi_disconnected_sensors: "Capteurs déconnectés (3 dernières heures)",
    kpi_maintenance_sensors: "Lectures de capteur peu plausibles",
    kpi_recommended_actions: "Arbres avec action recommandée",
    kpi_sensor_types: "Types de capteurs",
    kpi_total_sensors: "Nombre de capteurs",
    kpi_total_species: "Nombre d'espèces d'arbres",
    kpi_total_trees: "Nombre d'arbres",
    last_30_days: "30 derniers jours",
    last_3_hours: "3 dernières heures",
    no_data: "Aucune donnée disponible",
    no_health_data: "Aucune donnée de santé disponible",
    sensor_types: "Types de capteurs",
    tasks_by_due_period: "Tâches par période d'échéance",
    title: "Tableau de bord",
    top_species: "Top 5 des espèces d’arbres",
    top_species_info_body:
      "Affiche les espèces d'arbres les plus fréquentes dans les filtres actuels. Les valeurs sont basées sur le nombre d'arbres par espèce.",
    top_species_info_title: "Top 5 des espèces d’arbres",
    tree_health: "Santé des arbres",
    view_sensors: "Voir les capteurs",
    view_tasks: "Tâches ouvertes",
    view_trees: "Afficher les arbres",
    overview: "Vue d'ensemble",
    years_short: "années",
  },
  dashboards: "Tableaux de bord",
  esg: {
    title: "Suivi ESG",
    subtitle: "Efficacité des ressources",
    reporting_scope: "Périmètre du rapport",
    generate_pdf: "Générer PDF",
    export_csv: "Exporter CSV",
    data_quality: "Qualité des données",
    completed_irrigation_volume: "Volume d'irrigation effectué",
    estimated_water_saved: "Économie d'eau estimée",
    irrigation_efficiency: "Efficacité d'irrigation",
    estimated_co2_avoided: "CO2 évité estimé",
    liters: "litres",
    measured: "Mesuré",
    estimated: "Estimé",
    derived: "Dérivé",
    vs_last_period: "vs période précédente",
    irrigation_analysis: "Analyse de l'irrigation",
    monthly_comparison: "Comparaison mensuelle : ligne de base estimée vs. irrigation effectuée",
    monthly_comparison_through_current_month: "Comparaison mensuelle jusqu'au mois en cours inclus",
    baseline: "Ligne de base",
    completed: "Effectué",
    water_saved: "Eau économisée",
    methodology: "Méthodologie",
    calculation_basis: "Base de calcul",
    data_coverage: "Couverture des données",
    included_assumptions: "Hypothèses incluses",
    exclusions: "Exclusions et données manquantes",
    all_projects: "Tous les projets",
    all_areas: "Toutes les zones",
    disclaimer_title: "Avertissement",
    retry: "Réessayer",
    // Méthodologie – Base de calcul
    calc_volume_source:
      "Le volume d'irrigation réalisé est dérivé des tâches d'irrigation complétées et documentées.",
    calc_baseline_profile:
      "L'irrigation de référence utilise les profils de soin par défaut de TreeSense basés sur l'âge de l'arbre (année de plantation).",
    calc_seasonal_weighting:
      "La ligne de base mensuelle est distribuée selon un profil de pondération saisonnière concentré sur la saison d'irrigation d'avr–sep.",
    calc_water_saved:
      "Eau économisée = ligne de base moins volume d'irrigation effectué, limité à ≥ 0.",
    calc_co2_explanation:
      "Le CO₂e évité estimé est calculé en deux étapes. D'abord, les économies d'eau estimées sont converties en demande électrique évitée en utilisant l'intensité énergétique supposée du système hydraulique. Les économies d'électricité résultantes sont ensuite multipliées par le facteur d'émission électrique.",
    calc_co2_formula:
      "CO₂e évité estimé = Eau économisée (m³) × Intensité énergétique du système hydraulique (kWh/m³) × Facteur d'émission électrique (kg CO₂e/kWh)",
    // Méthodologie – Hypothèses incluses
    assumption_young_0_1: "Jeune arbre année 0–1 : 3 000 l/an (20 irrigations × 150 l)",
    assumption_young_2_3: "Jeune arbre années 2–3 : 1 800 l/an (12 irrigations × 150 l)",
    assumption_years_4_7: "Années 4–7 : 750 l/an (5 irrigations × 150 l)",
    assumption_established:
      "Arbres établis (>7 ans) : pas de ligne de base modélisée dans cette première version méthodologique (ne signifie pas un besoin d'irrigation nul).",
    assumption_energy_intensity:
      "Intensité énergétique du système hydraulique : 0,5 kWh/m³ (hypothèse interne de premier brouillon ; pas encore validée par rapport aux données locales des fournisseurs).",
    assumption_emission_factor:
      "Facteur d'émission électrique : 0,4 kg CO₂e/kWh (hypothèse interne de premier brouillon ; destiné à être remplacé par un facteur spécifique à l'année de déclaration et à la géographie).",
    assumption_seasonal:
      "Pondération saisonnière : la ligne de base est fortement concentrée en avr–sep (~76 %), avec une faible pondération résiduelle hors saison de pointe.",
    // Méthodologie – Exclusions
    exclusion_missing_planting_year:
      "{{count}} enregistrement(s) d'arbres exclu(s) de la ligne de base en raison de l'année de plantation manquante.",
    exclusion_large_transplant:
      "La ligne de base des grandes transplantations n'est pas encore modélisée séparément (pas de champ d'identification fiable).",
    exclusion_no_volume: "Les tâches sans volume extractible sont ignorées.",
    // Méthodologie – Avertissement
    disclaimer_text:
      "Le volume d'irrigation effectué est basé sur les entrées d'irrigation documentées en litres telles qu'enregistrées dans la plateforme TreeSense. L'eau économisée et le CO₂ évité sont des valeurs estimées calculées à l'aide de méthodologies et d'hypothèses standardisées.",
    // Qualité des données
    quality_good: "Bonne",
    quality_partial: "Partielle",
    quality_insufficient: "Insuffisante",
    methodology_details: "Détails de la méthodologie",
    methodology_version: "Version",
    methodology_updated: "Mis à jour",
    methodology_first_draft: "Mis à jour : premier brouillon",
    // Méthodologie – Références
    references: "Références",
    references_explanation:
      "Le GHG Protocol est utilisé comme base méthodologique pour convertir les données d'activité et la consommation d'électricité en émissions de gaz à effet de serre. La conversion eau-énergie de TreeSense et les facteurs numériques actuellement utilisés sont des hypothèses internes de premier brouillon.",
    ref_corporate_standard: "GHG Protocol Corporate Standard",
    ref_scope2_guidance: "GHG Protocol Scope 2 Guidance",
    without_project_not_supported:
      "Le suivi ESG n'est pas encore disponible pour les arbres sans projet. Sélectionnez un projet ou Tous les projets pour afficher le tableau de bord.",
    year: "Année",
    area: "Zone",
  },
  data_analysis: "Analyse des données",
  data_graphs: "Données et graphiques",
  data_interval_description:
    "Spécifiez comment les points de données doivent être regroupés dans le graphique.",
  data_interval_settings: "Paramètres d'intervalle de données",
  data_science: "Science des données",
  data_status: "Statut des données",
  date: "Date",
  date_time: "Date/Heure",
  datetime_photo: "Heure de capture de l'image",
  day: {
    fri: "Vendredi",
    mon: "Lundi",
    sat: "Samedi",
    sun: "Dimanche",
    thu: "Jeudi",
    tue: "Mardi",
    wed: "Mercredi",
  },
  day_friday: "Ven",
  day_monday: "Lun",
  day_saturday: "Assis",
  day_sunday: "Soleil",
  day_thursday: "Jeu",
  day_tuesday: "Mar",
  day_wednesday: "Épouser",
  days: "Jours",
  days_left: "jours restants",
  deadwood_removal: "Enlèvement du bois mort",
  default: "Défaut",
  default_legacy: "Par défaut, héritage",
  default_liters: "Litres par défaut",
  defect: "Défaut",
  defect_sensor: "Capteur défectueux présent",
  defect_sensors_excluded: "Les capteurs défectueux sont exclus du calcul",
  defect_sensors_info:
    "Les capteurs défectueux ou inaccessibles (affichés en gris) ne sont pas pris en compte dans le calcul de l'état de santé. Seuls les capteurs fonctionnels contribuent à l'état.",
  defect_types: "Types de défauts",
  delete: "Supprimer",
  delete_task: "Supprimer",
  demo_project_warning: {
    description:
      "Vous utilisez actuellement un compte démo et disposez d'autorisations limitées.\nSi vous êtes déjà client et souhaitez accéder à votre compte client, veuillez contacter le support : support@treesense.net.\nSi vous n'êtes pas encore client, vous pouvez commander des capteurs via notre boutique sur https://www.treesense.net",
    title: "Compte démo",
  },
  dendrometer: "Dendromètre",
  dendrometer_sensor: "Capteur dendromètre",
  tilt_sensor: "Capteur d'inclinaison",
  roll: "Roulis",
  pitch: "Tangage",
  tilt_roll: "Angle de roulis",
  tilt_pitch: "Angle de tangage",
  tilt_threshold: "Seuil d'inclinaison",
  tilt_alarm: "Alarme d'inclinaison",
  tilt_alarm_active: "Actif",
  tilt_alarm_inactive: "Pas d'alarme",
  tilt_alarm_email: "Email alarme d'inclinaison",
  task_notification_email: "Email d'attribution de tâche",
  tilt_calibrate: "Remettre à zéro",
  calibrating: "Calibration en cours...",
  tilt_calibrate_confirm: "Définir la position actuelle comme point zéro ?",
  depth: "Profondeur",
  description: "Description du projet",
  description_placeholder: "Décrivez brièvement le projet",
  deselect_all: "Tout désélectionner",
  dev_eui: "DevEUI",
  development_phase: "Phase de développement",
  development_trends: "Tendances de développement",
  diameter: "Diamètre",
  diameter_minus_start: "Changement de diamètre depuis le début",
  dieback: "Dépérissement",
  disconnected_sensors: "Capteurs déconnectés",
  documents: "Documents",
  dont_have_an_account: "Vous n'avez pas de compte ?",
  download: "Télécharger",
  download_csv: "Télécharger CSV",
  download_excel: "Télécharger Excel",
  download_pdf: "Télécharger le PDF",
  download_project_csv: "Télécharger les données du projet (fichiers TSV)",
  download_project_data: "Téléchargez toutes les données des capteurs pour ce projet",
  download_sensor_data: "Télécharger les données du capteur",
  download_successful: "Téléchargement réussi",
  download_tree_details: "Télécharger les détails des arbres (.pdf)",
  download_tree_list: "Télécharger la liste des arbres (.xlsx)",
  downloading: "Téléchargement…",
  drag_the_below_variables_to_graph_area:
    "Faites glisser les variables ci-dessous vers la zone graphique",
  drop_left: "Déposer à gauche",
  drop_right: "Déposer à droite",
  drop_the_variable_to_get_data: "Supprimez la variable. Continue!",
  drought_days: "Jours de sécheresse",
  ds_enter_fullscreen: "Mode de mise au point",
  ds_exit_fullscreen: "Quitter le mode de mise au point",
  ds_fetch_error_hint:
    "Veuillez réduire la plage de dates, sélectionner moins de capteurs ou réessayer.",
  ds_fetch_error_message:
    "Impossible de charger les données de séries chronologiques sélectionnées. La plage de temps ou le nombre de capteurs sélectionnés est peut-être trop grand.",
  ds_no_data_hint:
    "Aucune valeur n'a été trouvée pour les filtres et la plage horaire sélectionnés.",
  ds_no_data_message: "Aucune donnée disponible",
  ds_pending_reload_hint: 'Cliquez sur "Charger les données" pour actualiser le graphique.',
  ds_pending_reload_message:
    "Le graphique est masqué car votre sélection a changé et les données n'ont pas encore été rechargées.",
  due_date: "Date d'échéance",
  edit: "Modifier",
  edit_customer: "Modifier le client",
  edit_inspection: "Modifier l'inspection",
  edit_safety_assessment: "Modifier l'évaluation de la sécurité",
  edit_sensor: "Modifier le capteur",
  edit_task: "Modifier la tâche",
  edit_user: "Modifier l'utilisateur",
  edit_vta: "Modifier l'évaluation VTA",
  efc_info: {
    bullets: {
      a: "AWC = FC − PWP",
      b: "Représente l’eau disponible pour les plantes",
      c: "Important pour la planification de l’irrigation",
    },
    formula_intro:
      "Elle est calculée comme la différence entre la capacité au champ et le point de flétrissement permanent :",
    heading: "Capacité en eau disponible (AWC)",
    intro:
      "La capacité en eau disponible est la quantité d’eau réellement disponible pour les plantes.",
    note: "Valeurs plus élevées = le sol peut stocker plus d'eau et approvisionner les plantes plus longtemps",
  },
  effective_field_capacity: "Capacité de terrain efficace",
  either_fill_all_address_or_make_all_empty:
    "Soit remplissez toutes les adresses, soit laissez toutes les adresses vides.",
  email: "E-mail",
  email_field_is_required: "Le champ email est obligatoire",
  email_notification: "Notifications par courrier électronique",
  email_schedule: "Programme de courrier électronique",
  end: "Date de fin",
  enter_email_address: "Entrez l'adresse e-mail",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Entrez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  error: {
    a_valid_threshold_is_required: "Un seuil valide est requis",
    choose_location: "Choisir un emplacement",
    form: "Les valeurs ont été mal saisies. Veuillez les corriger et réessayer",
    hardware_serial_no_is_required: "Le numéro de série du matériel est requis",
    name_field_is_required: "Le champ Nom est obligatoire",
    please_choose_genus: "Veuillez choisir le genre",
    please_choose_species: "Veuillez choisir l'espèce",
    something_went_wrong: "Quelque chose s'est mal passé",
    this_field_is_required: "Ce champ est obligatoire",
  },
  error_loading_customers: "Erreur lors du chargement des clients",
  error_loading_trees: "Erreur lors du chargement des arbres",
  error_loading_users: "Erreur lors du chargement des utilisateurs",
  evaluation: "Évaluation",
  existing_area: "Zone existante",
  expiration_date: "Date d'expiration",
  explanation: "Explication",
  export: "Exporter",
  export_data: "Exporter les données",
  export_tasks: "Exporter les tâches",
  export_irrigation_description:
    "Exporter les tâches d'irrigation vers Excel. Affiche toutes les entrées de la saison de végétation actuelle (avril - octobre).",
  export_tasks_description:
    "Exporter les tâches vers Excel. Affiche les tâches terminées et planifiées regroupées par arbre.",
  no_data_to_export: "Aucune donnée à exporter",
  no_tasks_found: "Aucune tâche trouvée pour les filtres sélectionnés.",
  export_sensor_description:
    "Exportez les mesures de capteur disponibles pour la période sélectionnée.",
  favorites: "Favoris",
  fc_info: {
    after_rain: "Après arrosage ou pluie :",
    bullets: {
      a: "L'excès d'eau s'infiltre",
      b: "Le sol se stabilise à la capacité du champ",
      c: "Il est préférable de commencer à surveiller l’irrigation avant que le PWP ne soit atteint",
    },
    heading: "Capacité de terrain (FC)",
    intro:
      "La capacité au champ est la quantité maximale d’eau que le sol peut retenir contre la gravité.",
    note: "Valeurs typiques : 35 à 50 % (dépend du type de sol)",
  },
  feedback: "Retour",
  feedback_category: "Catégorie",
  feedback_category_bug: "Rapport de bug",
  feedback_category_feature_request: "Demande de fonctionnalité",
  feedback_category_positive: "Commentaires positifs",
  feedback_description: "Description",
  feedback_priority: "Priorité",
  feedback_priority_critical: "Critique",
  feedback_priority_high: "Haut",
  feedback_priority_low: "Faible",
  feedback_priority_medium: "Moyen",
  feedback_problem_url: "URL du problème",
  feedback_screenshot: "Capture d'écran",
  feedback_submit_success: "Commentaires enregistrés avec succès.",
  field_capacity: "Capacité sur le terrain",
  file_download_success: "Le fichier a été téléchargé avec succès !",
  export_failed: "L'exportation a échoué. Veuillez réessayer.",
  file_upload_successfully: "Téléchargement du fichier réussi",
  files_selected: "Fichiers sélectionnés",
  filter: "Filtre",
  filter_by_location: "Filtrer par emplacement",
  filter_by_project: "Filtrer par projet",
  filter_tasks: "Filtre",
  filters: "Filtres",
  findings: "Résultats",
  first_name: "Prénom",
  focus_search: "Recherche ciblée",
  foliage_density: {
    full: "Complet",
    moderate: "Modéré",
    sparse: "Clairsemé",
    very_sparse: "Très clairsemé",
  },
  foliagedensity: "Densité du feuillage",
  forgotpassword: "Mot de passe oublié ?",
  formula_type: "Formule",
  from: "Depuis",
  fungal_infection: "Infection fongique",
  future_tasks: "Avenir",
  gallery: "Galerie",
  general: "Général",
  genus: "Genre",
  german_name: "ge. Nom",
  go_to_customers: "Aller vers les clients",
  go_to_users: "Allez dans Utilisateurs",
  greeting: "Bonjour",
  group_biometrics: "Biométrie des arbres",
  group_inventory: "Inventaire des arbres",
  group_sensors: "État du capteur",
  growth_rate: {
    normal: "Normale",
    slow: "Lent",
    stagnant: "Stagnant",
    vigorous: "Vigoureux",
  },
  growth_rate_label: "Taux de croissance",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "L'identification unique du capteur. Il se trouve sur l'autocollant apposé sur le module émetteur. Pour les capteurs LoRaWAN, il s'agit du DevEUI et pour les capteurs NB-IoT, il s'agit de l'IMEI.",
  hardware_serial_no: "Série matérielle",
  head_purning: "Taille de la tête",
  health_of_tree_is_drying_out: "La santé de l'arbre se dessèche",
  health_of_tree_is_good: "L’état de santé de l’arbre est bon",
  health_of_tree_is_poor: "La santé de l'arbre est mauvaise",
  health_overview: "Aperçu de la santé",
  health_priority: "Priorité",
  health_state: "État de santé",
  health_state_info: {
    heading: "Système de feux tricolores : comprendre le besoin d’irrigation",
    intro:
      "Le système de feux tricolores indique d'un seul coup d'œil si un arbre a besoin d'être irrigué :",
    note: "Important : Le signal est basé sur des mesures et des seuils configurés pour cet arbre, ce type de sol et cet emplacement.",
    states: {
      blue_help: "Sur-irrigué ; risque d’engorgement.",
      blue_label: "🔵 Bleu – Trop humide :",
      gray_help: "Capteur indisponible ou pas de données.",
      gray_label: "⚪ Gris – Inconnu :",
      green_help: "L'arbre a suffisamment d'eau.",
      green_label: "🟢 Vert – Aucune irrigation nécessaire :",
      red_help: "Irriguez immédiatement !",
      red_label: "🔴 Rouge – Irrigation urgente :",
      yellow_help: "Irriguer si cela est opérationnellement possible.",
      yellow_label: "🟡 Jaune – Irrigation recommandée :",
    },
  },
  health_states: {
    critical: "Critique",
    critical_todo:
      "L’arbre souffre très probablement du stress de la sécheresse. Irriguez-le dès que possible.",
    determines_tree_status: "Ce capteur détermine l'état de l'arbre",
    disconnect: "Déconnecter",
    dry: "Sec",
    dry_todo: "L'arbre doit être arrosé ou vérifié dès que possible.",
    drying_out: "Dessèchement",
    drying_out_todo: "L'arbre doit être arrosé.",
    frost: "Gel",
    frost_todo: "L'arbre pourrait subir des dommages dus au gel.",
    healthy: "En bonne santé",
    healthy_todo:
      "L'arbre dispose d'un bon approvisionnement en eau. Vous n’avez aucune mesure à prendre.",
    info_only: "À titre indicatif, ne détermine pas l'état de l'arbre",
    maintenance_needed: "Lectures de capteur peu plausibles",
    maintenance_needed_todo:
      "Les lectures du capteur semblent invraisemblables. Vérifiez et entretenez le capteur.",
    medium: "Moyen",
    mixed_sensors: "Les capteurs montrent différents états",
    no_data: "Aucune donnée",
    no_data_todo:
      "Le capteur est installé mais n’envoie pas de données. Vérifiez la connexion du capteur.",
    no_sensor: "Aucun capteur",
    no_sensor_todo:
      "Aucun capteur installé. Installez un capteur pour surveiller le stress hydrique.",
    priority_1_crown: "Capteurs de couronne (si présents, seuls ceux-ci comptent)",
    priority_2_soil: "Capteurs de sol (uniquement s'il n'y a pas de capteurs de couronne)",
    priority_3_dendrometer: "Dendromètre (uniquement s'il n'y a pas d'autres capteurs)",
    priority_explanation: "L'état de santé repose sur un système de priorités :",
    priority_note:
      "💡 Dans la vue détaillée, vous pouvez voir tous les capteurs. Toutefois, l'état de l'arborescence est uniquement déterminé par la priorité disponible la plus élevée.",
    priority_title: "Comment est calculé le statut ?",
    soil_needs_attention:
      "Les capteurs de sol affichent des valeurs critiques même si la couronne est saine",
    status_from_crown:
      "Status based on crown sensor: {{crownStatus}}\n(Soil sensor: {{soilStatus}} - for information only)",
    status_from_soil: "État basé sur le capteur de sol (aucun capteur de couronne présent)",
    too_wet: "Trop humide",
    too_wet_todo: "L'arbre ou le sol semble trop humide et ne doit pas être arrosé.",
    unknown: "Inconnu",
    unknown_todo: "Le capteur doit être vérifié.",
    wet: "Trop mouillé",
    wet_todo: "L'arbre ou le sol est trop humide. Ne pas arroser l'arbre.",
  },
  health_states_title: "État de santé",
  healthy: "En bonne santé",
  heatmaps: "Cartes thermiques",
  height: "Hauteur",
  help: "Aide",
  history: "Histoire",
  house_number: "Numéro de maison",
  hypotheses: "Hypothèses à tester",
  hypotheses_placeholder: "Quelles hypothèses tester ?",
  image: "Image",
  imei: "IMEI",
  impact: "Impact",
  import_export: "Importer/Exporter",
  import_trees: "Importer des arbres",
  improvements: "Améliorations",
  inactive: "Inactif",
  include_advanced_calibration_values: "Inclure des valeurs avancées d’étalonnage/débogage",
  include_calculated_values: "inclure des valeurs calculées",
  include_mean_values: "Inclure les valeurs moyennes",
  include_mean_values_hint:
    "Ajoute des valeurs moyennes pour la période sélectionnée à l'exportation.",
  include_new_moisture_content_data:
    "Inclure une nouvelle teneur en humidité (cartographie des espèces)",
  include_old_moisture_content_data: "Inclure l'ancienne teneur en humidité (schwarzpappel)",
  include_species_mapping_data:
    "Inclure en outre les données d'étalonnage de la cartographie des espèces",
  index: "Indice",
  info: "Informations",
  inspection_date: "Date d'inspection",
  inspection_result: {
    failed: "Échoué",
    passed: "Passé",
    passed_with_notes: "Réussi avec notes",
  },
  inspection_result_label: "Résultat du contrôle",
  inspection_type: {
    detailed: "Inspection détaillée",
    emergency: "Inspection d'urgence",
    post_storm: "Inspection après tempête",
    routine: "Inspection de routine",
    safety: "Inspection de sécurité",
  },
  inspection_type_label: "Type de contrôle",
  inspections: "Inspections",
  inspector: "Inspecteur",
  install: "Installer",
  install_sensor: "Installer le capteur",
  installation: "Installation",
  installation_save_failed: "Impossible d'enregistrer l'installation. Veuillez réessayer.",
  installed_at: "Date d'installation",
  installed_sensors: "Capteurs installés",
  interactive_map: "Carte interactive",
  interval_settings: "Intervalle",
  invalid_date: "Date invalide",
  invalid_date_range: "La date de début doit être antérieure à la date de fin.",
  invalid_email_address: "Adresse e-mail invalide",
  irrigation: "Irrigation",
  irrigationArea: "Zone d'irrigation",
  irrigation_area_assignees_hint:
    "Définissez qui doit être affecté par défaut aux tâches d'irrigation créées ou préparées automatiquement par zone.",
  irrigation_area_assignees_title: "Personne responsable par zone",
  irrigation_auto_create_task: "Créer automatiquement une tâche (ignorer la suggestion)",
  irrigation_cycle_count_label: "Nombre de cycles d'arrosage",
  irrigation_default_volumes: "Volumes d'irrigation par défaut",
  irrigation_interval_biweekly: "Toutes les 2 semaines",
  irrigation_interval_custom: "Personnalisé (X jours)",
  irrigation_interval_daily: "Tous les jours",
  irrigation_interval_title: "Intervalle d'irrigation",
  irrigation_interval_weekly: "Hebdomadaire",
  irrigation_no_areas: "Aucune zone disponible.",
  irrigation_phase_default: "Aucune phase (par défaut)",
  irrigation_repeat_every: "Répétez tous les",
  irrigation_settings: "Irrigation",
  irrigation_settings_saved: "Paramètres d'irrigation enregistrés.",
  irrigation_stop_condition_title: "Condition d'arrêt",
  irrigation_stop_fixed_cycles: "Nombre de cycles fixe",
  irrigation_stop_until_green: "Continuer jusqu'à ce que l'état de santé revienne au vert",
  irrigation_suggestion_assignment_mode_area_default: "Personne responsable par défaut par zone",
  irrigation_suggestion_assignment_mode_hint:
    "Choisissez si les suggestions d’irrigation doivent utiliser la personne responsable par défaut par zone ou nécessiter une sélection manuelle à chaque acceptation.",
  irrigation_suggestion_assignment_mode_manual:
    "Choisir manuellement la personne responsable à chaque acceptation",
  irrigation_suggestion_assignment_mode_title: "Devoir de suggestions",
  irrigation_trigger_after_days: "Déclenchement après X jours",
  irrigation_trigger_conditions: "Conditions de déclenchement",
  irrigation_trigger_red: "Déclenchement lorsque l'état de santé est rouge",
  irrigation_trigger_yellow: "Déclenchement lorsque l'état de santé est jaune",
  irrigation_validation_custom_days: "Veuillez saisir un intervalle personnalisé valide en jours.",
  irrigation_validation_fixed_cycles: "Veuillez saisir un nombre de cycles fixe valide.",
  keyboard_shortcuts: "Raccourcis clavier",
  kpi_avg_age: "Âge moyen",
  kpi_avg_crown_diameter: "Diamètre moyen de la couronne",
  kpi_avg_height: "Taille moyenne",
  kpi_avg_trunk_diameter: "Diamètre moyen du tronc",
  kpi_critical_sensors: "Capteurs critiques",
  kpi_disconnected_sensors: "Capteurs déconnectés (3 dernières heures)",
  kpi_sensor_types: "Types de capteurs",
  kpi_total_sensors: "Nombre de capteurs",
  kpi_total_species: "Nombre d'espèces d'arbres",
  kpi_total_trees: "Nombre d'arbres",
  language: "Langue",
  language_description: "Sélectionnez votre langue préférée",
  last_10_measurements: "10 dernières mesures",
  last_battery: "Dernière batterie",
  last_date: "Dernière date",
  last_measurements: "Dernières mesures",
  last_name: "Nom de famille",
  last_value: "Dernière valeur",
  latin_name: "lat. Nom",
  latitude: "Latitude",
  leaf_photos: "Feuille Photos",
  leave_empty_to_keep_current: "Laisser vide pour conserver le mot de passe actuel",
  less_than_60_of_the_battery_remaining: "Moins de 60 % de la batterie restante",
  ligature_control: "Contrôle des ligatures",
  limitations: "Limites des résultats/importance",
  limitations_placeholder: "Quelle est l’importance des résultats ? Quelles sont les limites ?",
  limits_alerts: "Limites et alertes",
  live_monitoring: "Surveillance en direct",
  load_data: "Charger des données",
  loading: "Chargement ...",
  loading_data: "Chargement des données...",
  loading_trees: "Chargement des arbres…",
  location: "Emplacement",
  login: "Se connecter",
  login_credentials: "Identifiant de connexion",
  logout: "Se déconnecter",
  longitude: "Longitude",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Il semble que vous n'ayez pas sélectionné de zone. Veuillez sélectionner une zone pour obtenir des données.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Il semble que vous n'ayez pas sélectionné de capteur. Veuillez sélectionner un capteur pour obtenir des données.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "On dirait que vous n'avez pas sélectionné d'arbre. Veuillez sélectionner un arbre pour obtenir des données.",
  lora_wan: "LoRaWAN",
  maintainance: "Entretien",
  maintenance: "Entretien",
  maintenance_needed: "Lectures de capteur peu plausibles",
  manage_customers_description: "Gérer les informations et les accès des clients",
  manage_parent_child_relationships: "Gérer les relations parents-enfants",
  manage_trees_without_sensors: "Gérer les arbres sans capteurs",
  manage_users_description: "Gérer les comptes d'utilisateurs et les autorisations",
  map_add_tree_hint: "Déplacez la carte pour définir l'emplacement de l'arborescence.",
  map_add_tree_mode: "Mode de positionnement actif",
  map_sidebar_info: {
    description:
      "Cette barre latérale répertorie toutes les zones d'irrigation et leurs arbres dans une vue hiérarchique.",
    features: {
      add_tree_help: "Utilisez l'icône plus pour ajouter de nouveaux arbres à une zone.",
      add_tree_label: "Ajouter un arbre :",
      expand_areas_help: "Cliquez sur une zone pour afficher tous les arbres associés.",
      expand_areas_label: "Développer les zones :",
      parent_child_help:
        "Les arbres équipés de capteurs peuvent agir comme arbres parents et représenter des arbres supplémentaires.",
      parent_child_label: "Relations parents-enfants :",
      select_tree_help: "Cliquez sur un arbre pour l'afficher sur la carte et ouvrir ses détails.",
      select_tree_label: "Sélectionnez un arbre :",
    },
    features_heading: "Caractéristiques:",
    heading: "Navigation dans la vue cartographique",
    note: "Le code couleur des arbres reflète l'état de santé (vert = sain, jaune = en séchage, rouge = sec, gris = inconnu).",
    title: "Vue cartographique – Zones et arbres",
  },
  map_view: "Vue cartographique",
  mark_all_as_seen: "Marquez tout comme vu.",
  mark_as_Seen: "Marquer comme vu",
  master_data: "Gestion des données de référence",
  materials: "Fichiers/Photos/Matériaux du projet",
  materials_placeholder: "Liens vers des fichiers, des photos ou d'autres documents",
  maximum_of: "Maximum",
  mean: "Signifier",
  meaning_measurement: "Signification de la mesure",
  measure_type_free_entry: "Entrée gratuite",
  measure_type_inspection: "Inspection",
  measure_type_irrigation: "Irrigation",
  measure_type_pruning: "Taille",
  measure_type_sensor_maintenance: "Entretien du capteur",
  measure_type_soil_maintenance: "Entretien des sols",
  menu: "Menu",
  methodology: "Comment répondre à la question ? (Méthodologie, sélection d'arbres, installation)",
  methodology_placeholder:
    "Décrire la méthodologie, les emplacements, la sélection des arbres, l'installation des capteurs...",
  mobile_column: "Colonne",
  mobile_table_column_preferences: "Colonnes mobiles",
  mobile_table_column_preferences_hint:
    "Choisissez les 2 colonnes à afficher sur les appareils mobiles (smartphones).",
  moisture_content: "Indice d’humidité Treesense",
  moisture_content_cap_description:
    "Valeurs limites à 0-1 / 0-100 %. Désactivez pour afficher les valeurs analytiques brutes.",
  moisture_content_cap_setting: "Valeurs de teneur en humidité du bouchon",
  moisture_content_display_description:
    "Choisissez la façon dont TreeSense affiche les valeurs de teneur en humidité.",
  moisture_content_display_fraction: "Fraction (0-1)",
  moisture_content_display_fraction_description: "Afficher les valeurs à 0,34.",
  moisture_content_display_percent: "Pourcentage (0-100)",
  moisture_content_display_percent_description: "Afficher les valeurs à 34 %.",
  moisture_content_display_setting: "Affichage de la teneur en humidité",
  moisture_formula_hint:
    "La nouvelle formule compense mieux les effets de la température et fournit des valeurs plus stables.",
  moisture_formula_improvements:
    "Nous avons considérablement amélioré et automatisé la configuration de l’étalonnage de la température. Auparavant, seul le peuplier noir était indemnisé. Nous essayons désormais de compenser autant d’espèces d’arbres que possible. Si cela n’est pas possible, nous utilisons les espèces d’arbres phylogénétiquement les plus proches.",
  moisture_formula_learn_more: "Apprendre encore plus",
  moisture_formula_new_description:
    "Généralement plus stable car il compense mieux les effets de la température. Cependant, cela peut rendre les événements d’irrigation ou de pluie moins perceptibles.",
  moisture_formula_note:
    "Remarque : Le choix de la formule affecte l'affichage des valeurs d'humidité dans tous les graphiques.",
  moisture_formula_old_description:
    "Plus affecté par les fluctuations de température, mais peut montrer plus clairement les événements d'irrigation et de pluie.",
  moisture_formula_setting: "Formule de teneur en humidité",
  moisture_formula_threshold_warning:
    "Lors de l'utilisation de la nouvelle formule, les seuils changent également. Ils doivent être revus et ajustés après le changement afin que les avertissements et les évaluations restent corrects.",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  month_april: "Avril",
  month_august: "Août",
  month_december: "Décembre",
  month_february: "Février",
  month_january: "Janvier",
  month_july: "Juillet",
  month_june: "Juin",
  month_march: "Mars",
  month_may: "Peut",
  month_november: "Novembre",
  month_october: "Octobre",
  month_september: "Septembre",
  more_actions: "Plus de propositions",
  more_information: "Plus d'informations",
  more_tasks: "plus",
  move_down: "Descendre",
  move_up: "Monter",
  name: "Nom",
  navigation: "Navigation",
  nb_iot: "NB-IoT",
  network_type: "Type de réseau",
  new_area: "Nouvelle zone",
  new_formula: "Nouvelle formule",
  new_project: "Nouveau projet",
  new_task: "Nouvelle tâche",
  newproject: "Nouveau projet",
  next_inspection: "Prochaine inspection",
  next_inspection_date: "Prochaine date de contrôle",
  next_irrigation: "Irrigation suivante",
  no_data: "Aucune donnée disponible",
  no_data_available_please_check_data_available_to_this_date:
    "Aucune donnée disponible, veuillez vérifier les données disponibles à cette date",
  no_data_for_selected_range:
    "Aucune donnée disponible pour la plage horaire et les paramètres sélectionnés.",
  no_data_found: "Aucune donnée trouvée",
  no_health_data: "Aucune donnée de santé disponible",
  no_inspections: "Aucune inspection enregistrée",
  no_installation: "Aucune installation",
  no_photos: "Aucune photo téléchargée",
  no_project_selected: "Aucun projet sélectionné",
  no_projects_available: "Aucun projet disponible",
  no_results: "Aucun résultat",
  no_results_action: "Réinitialiser les filtres",
  no_safety_assessments: "Aucune évaluation de sécurité enregistrée",
  no_sensor_is_selected: "Aucun capteur n'est sélectionné",
  no_sensor_mode: "Mode sans capteur",
  no_sensors_found: "Aucun capteur trouvé",
  no_tasks: "Aucune tâche disponible",
  no_tasks_subtitle: "Créez votre première tâche",
  no_tree_is_selected: "Aucun arbre n'est sélectionné",
  no_trees_available: "Aucun arbre disponible",
  no_trees_found: "Aucun arbre trouvé",
  no_vta_assessments: "Aucune évaluation VTA enregistrée",
  not_found: "Pas trouvé",
  not_provided: "Non fourni",
  not_sending: "Pas d'envoi",
  note: "Note",
  notes: "Remarques",
  notifications: "Notifications",
  number_of_tree_based_on_health_status: "Nombre d'arbres en fonction de l'état de santé",
  number_of_tree_on_respective_area: "Nombre d'arbres sur la zone respective",
  of: "de",
  okay: "D'accord",
  old_formula: "Ancienne formule",
  one_day: "1 jour",
  one_day_info: "Afficher les données des dernières 24 heures",
  one_week: "1 semaine",
  one_week_info: "Afficher les données des 7 derniers jours",
  one_year: "1 an",
  one_year_info: "Afficher les données des 12 derniers mois",
  open: "Ouvrir",
  open_questions: "Questions ouvertes / Prochaines étapes",
  open_questions_placeholder:
    "Quelles questions restent ouvertes ? Quelles sont les prochaines étapes ?",
  open_sidebar: "Ouvrir la barre latérale",
  open_time_controls: "Contrôles de temps d'ouverture",
  optional_soil_name: "Nom du sol facultatif",
  other: "Autre",
  overall: "Dans l'ensemble",
  overdue: "En retard",
  overview: "Aperçu",
  pagination_out_of: "de",
  parentTree: "Arbre parent",
  parent_child_mode: "Mode parent-enfant",
  password: "Mot de passe",
  password_do_not_match: "Le mot de passe ne correspond pas",
  password_field_is_required: "Le champ Mot de passe est obligatoire",
  password_reset_request_sent_generic:
    "S'il existe un compte pour cet e-mail, nous vous enverrons un lien de réinitialisation.",
  past_tasks: "Passé",
  permanent_wilting_point: "Point de flétrissement permanent",
  persona: "Personnage",
  persona_labels: {
    city_tree_manager: "Gestionnaire d'arbres de la ville",
    irrigation_team: "Équipe d'irrigation",
    research_partner: "Partenaire de recherche",
    tree_inspector: "Inspecteur des arbres",
    treesense_support: "Prise en charge de TreeSense",
  },
  personal_data: "Données personnelles",
  pest_infestation: "Infestation parasitaire",
  phase: "Phase",
  phone_number: "Numéro de téléphone",
  photos: "Photos",
  planting_time: "Temps de plantation",
  planting_year: "Année de plantation",
  please_drag_the_variable_to_display_data:
    "Veuillez faire glisser la variable pour afficher les données.",
  please_select_project: "Veuillez sélectionner un projet pour afficher les données",
  please_select_project_to_view_map: "Veuillez sélectionner un projet pour voir la carte",
  please_select_sensor: "Veuillez sélectionner un capteur.",
  position: "Position",
  position_confirmed: "Poste confirmé",
  print_tree_tag: "Imprimer l'étiquette de l'arbre",
  priority: {
    high: "Haut",
    low: "Faible",
    medium: "Moyen",
    urgent: "Urgent",
  },
  priority_high: "Haut",
  priority_low: "Faible",
  priority_medium: "Moyen",
  problem_in_creating_customer: "Problème de création de client",
  problem_in_creating_sensor: "Problème de création de capteur",
  profile: "Profil",
  proj: "Projet",
  project: {
    aim: "Type de projet",
    aim_general_drought_stress_monitoring: "Surveillance générale du stress dû à la sécheresse",
    aim_groundwater_lowering_monitoring: "Surveillance de l'abaissement des eaux souterraines",
    aim_irrigation_demand_determination: "Détermination de la demande d'irrigation",
    aim_irrigation_optimization: "Optimisation de l'irrigation",
    aim_irrigation_optimization_young_trees: "Optimisation de l'irrigation : jeunes arbres",
    aim_mistletoe_control: "Contrôle du gui",
    aim_old_tree_monitoring: "Surveillance des vieux arbres",
    aim_partnership_project: "Projet de partenariat",
    aim_smart_city: "Ville intelligente",
    aim_technology_validation: "Validation de la technologie",
    challenges: "Problèmes pendant le projet",
    challenges_placeholder: "Quels problèmes sont survenus ? De quoi le client avait-il besoin ?",
    description: "Description du projet",
    description_placeholder: "Décrivez brièvement le projet",
    hypotheses: "Hypothèses à tester",
    hypotheses_placeholder: "Quelles hypothèses tester ?",
    limitations: "Limites des résultats/importance",
    limitations_placeholder: "Quelle est l’importance des résultats ? Quelles sont les limites ?",
    materials: "Fichiers/Photos/Matériaux du projet",
    materials_placeholder: "Liens vers des fichiers, des photos ou d'autres documents",
    methodology: "Méthodologie",
    methodology_placeholder:
      "Décrire la méthodologie, les emplacements, la sélection des arbres et l'installation des capteurs...",
    name: "Nom du projet",
    open_questions: "Questions ouvertes / Prochaines étapes",
    open_questions_placeholder:
      "Quelles questions restent ouvertes ? Quelles sont les prochaines étapes ?",
    research_question: "Question de recherche",
    research_question_placeholder: "Quelle est la question centrale de la recherche ?",
    results: "Résultats",
    results_placeholder: "Quels sont les principaux résultats du projet ?",
    select_aim: "Sélectionnez le type de projet",
  },
  project_details: {
    empty_project: "Projet vide, veuillez commencer à ajouter des arbres.",
    empty_sensors: "Aucun capteur créé, veuillez commencer par ajouter des capteurs.",
    empty_trees: "Arbres vides, veuillez commencer à ajouter des arbres.",
    no_area_selected: "Veuillez sélectionner une zone pour afficher les détails",
    no_sensor_selected: "Veuillez sélectionner un capteur pour afficher les détails.",
    no_tree_selected: "Veuillez sélectionner un arbre pour voir les détails",
  },
  project_name: "Projet",
  project_not_found: "Projet introuvable",
  projects: "Projets",
  projects_views: "Projets",
  pulse_resistance_in_kOhm: "Résistance d'impulsion en kOhm",
  pulse_sensor: "Capteur de pouls",
  push_message_notification: "Notifications de messages push",
  pwp_info: {
    bullets: {
      a: "Les plantes ne peuvent plus absorber suffisamment d'eau",
      b: "Des dommages irréversibles peuvent survenir",
      c: "L’irrigation immédiate est essentielle",
    },
    heading: "Point de flétrissement permanent (PWP)",
    intro:
      "Le point de flétrissement permanent est la teneur en eau du sol à partir de laquelle les plantes ne peuvent plus absorber d'eau.",
    note: "Valeurs typiques : 10 à 15 % (dépend du type de sol)",
    when_reached: "Lorsque l’humidité du sol atteint ou descend en dessous de cette valeur :",
  },
  qr_scanner: "Scanner QR",
  rain: "Pluie",
  rainfall: "Précipitations",
  rainfall_mm: "Précipitations (mm)",
  reason: "Raison",
  recommendations: "Recommandations",
  records: "Enregistrements",
  reference: "Référence",
  refresh_health: "Actualiser les données de santé",
  refresh_health_error: "Échec de l'actualisation des données de santé",
  remove: "Retirer",
  remove_3d_model: "Supprimer le modèle 3D",
  removed_at: "Date de retrait",
  replace_3d_model: "Remplacer le modèle 3D",
  report_after: "Après",
  report_avg_control_interval: "Intervalle de contrôle moyen",
  report_avg_moisture_index: "Indice d'humidité moyen",
  report_avg_moisture_over_time: "Indice d'humidité moyen dans le temps",
  report_avg_violation_to_completion: "Moy. violation de l'achèvement de la tâche",
  report_batteries_low: "Piles < 20%",
  report_before: "Avant",
  report_before_after_analysis: "Analyse avant/après",
  report_completed_tasks: "Tâches terminées",
  report_controls_per_month: "Contrôles par mois",
  report_controls_performed: "Contrôles effectués",
  report_critical_trees: "Arbres critiques",
  report_critical_vs_completed: "Arbres critiques vs mesures réalisées",
  report_critical_with_open_task: "Arbres critiques avec tâche ouverte",
  report_date: "Date",
  report_documented_maintenance: "Actions de maintenance documentées",
  report_effect_tab: "Rapport d'effet",
  report_health_distribution: "Répartition de l'état de santé",
  report_index_change_after_irrigation: "Changement d'indice après irrigation",
  report_index_change_after_pruning: "Changement d'indice après la taille",
  report_irrigation_vs_index: "Irrigations vs indice moyen",
  report_kataster_tab: "Rapport Kataster",
  report_maintenance_type_distribution: "Répartition des types d'entretien",
  report_offline_sensors: "Capteurs hors ligne",
  report_overdue_tasks: "Tâches en retard",
  report_rain_vs_index: "Pluie vs indice moyen",
  report_range_1m: "1 mois",
  report_range_1w: "1 semaine",
  report_range_1y: "1 an",
  report_range_3m: "3 mois",
  report_sensor_tab: "Rapport du capteur",
  report_task_status_distribution: "Répartition du statut des tâches",
  report_threshold_violations: "Violations de seuil",
  report_total_active_sensors: "Total des capteurs actifs",
  report_total_trees: "Total des arbres",
  report_violations: "Violations",
  reporting: "Rapports",
  reports_analysis: "Rapports et analyses",
  represent_tree: "Représenter l'arbre",
  represented_tree: "Arbre représenté",
  required: "Requis",
  required_information: "*Informations requises",
  research_question: "Question de recherche/Objectifs du projet",
  research_question_placeholder: "Quelle est la question ou l’objectif principal de ce projet ?",
  reset: "Réinitialiser",
  reset_chart: "Réinitialiser le graphique",
  reset_filters: "Tout réinitialiser",
  reset_info: "Réinitialiser tous les paramètres du graphique par défaut",
  reset_password: "Réinitialiser le mot de passe",
  reset_table_column_preferences: "Restaurer les valeurs par défaut",
  reset_zoom: "Réinitialiser le zoom",
  resis_temp_comp: "RésisTempComp",
  resistance: "Résistance",
  resource_planning: "Planification des ressources",
  restore_view: "Restaurer la vue",
  data_science_chart_tools: "Outils du graphique",
  results: "Résultats",
  results_placeholder: "Quels sont les principaux résultats du projet ?",
  risk_assessment: "L'évaluation des risques",
  risk_level: {
    critical: "Risque critique",
    high: "Risque élevé",
    low: "Faible risque",
    medium: "Risque moyen",
  },
  risklevel: "Niveau de risque",
  role: "Rôle",
  root_ball: "Motte de racines",
  root_defects: "Défauts racinaires",
  root_system: {
    DE: "Profondément enraciné",
    HE: "Enraciné dans le cœur",
    SH: "À racines peu profondes",
    UN: "Inconnu",
  },
  safety_status: {
    action_required: "Action requise",
    monitoring_required: "Surveillance requise",
    safe: "Sûr",
    unsafe: "Dangereux",
  },
  save: "Sauvegarder",
  save_changes: "Enregistrer les modifications",
  save_settings: "Enregistrer les paramètres",
  saved: "Enregistré",
  saving: "Économie",
  scan_to_add_sensor: "Scanner pour ajouter un capteur",
  search: "Recherche",
  search_address: "Rechercher une adresse",
  search_area: "Zone de recherche",
  search_sensor: "Capteur de recherche",
  search_sensors: "Rechercher des capteurs...",
  search_tasks: "Rechercher des tâches...",
  search_tree: "Arbre de recherche",
  search_trees: "Rechercher des arbres...",
  select_aim: "Sélectionnez l'objectif du projet",
  select_all: "Tout sélectionner",
  select_camera: "Sélectionnez la caméra",
  select_child_trees: "Sélectionner des arbres enfants",
  select_customer_type: "Sélectionnez le type de client",
  select_depth: "Sélectionnez la profondeur",
  select_language: "Sélectionnez la langue",
  select_phase: "Sélectionnez la phase",
  select_project: "Sélectionnez un projet",
  select_sensor: "Sélectionnez le capteur",
  select_sensor_search: "Rechercher un capteur...",
  select_task_types: "Sélectionnez les types de tâches",
  select_year: "Choisir l'année",
  send_feedback: "Envoyer des commentaires",
  sending: "Envoi...",
  sensor: "Capteur",
  sensor_already_installed: "Ce capteur est déjà activement installé.",
  sensor_configuration: "Configuration du capteur",
  sensor_data: "Données du capteur",
  sensor_details: {
    empty_sensors: "Capteur vide, veuillez commencer à ajouter des arbres.",
    no_data_found: "Aucune donnée de capteur trouvée",
    no_recent_measurements: "Aucune mesure au cours des 3 derniers mois.",
    no_recent_measurements_hint:
      "Pour inspecter des données plus anciennes, utilisez la vue d'analyse des données et ajustez la plage de temps.",
    no_sensor_selected: "Veuillez sélectionner le capteur pour afficher les détails",
    no_evaluation_possible: "Aucune évaluation possible.",
  },
  sensor_disconnect: "Déconnexion du capteur",
  sensor_form: {
    hardware_serial: "Série matérielle",
    name: "Nom",
    network_type: "Type de réseau",
    sensor_type: "Type de capteur",
    threshold: "Seuil",
  },
  sensor_name: "Nom du capteur",
  sensor_state: "État du capteur",
  sensor_status: "État du capteur",
  sensor_status_change_to_dry: "L'état du capteur passe à sec",
  sensor_status_change_to_drying_out: "Changement d'état du capteur en séchage",
  sensor_status_change_to_no_connection: "L'état du capteur passe à aucune connexion",
  sensor_status_description:
    "L'état du capteur indique si le capteur fonctionne ou s'il nécessite une maintenance",
  sensor_type: "Type de capteur",
  sensor_types: "Types de capteurs",
  sensors: "Capteurs",
  sensors_monitoring: "Capteurs et surveillance",
  sensors_views: "Capteurs",
  sesnor_height_hint:
    "Faites glisser l'icône du capteur ou entrez la hauteur. Les valeurs sont arrondies.",
  set_default: "Définir par défaut",
  settings: "Paramètres",
  settings_saved_successfully: "Paramètres enregistrés avec succès",
  settings_user_info: {
    persona: {
      city_tree_manager: {
        changes: [
          "Page par défaut\u00a0: Tableau de bord",
          "Focus\u00a0: travaux axés sur la vue d’ensemble, le cadastre et le reporting",
        ],
        description:
          "Profil UX pour les utilisateurs qui ont besoin d’une vue d’ensemble orientée gestion sur le tableau de bord, le cadastre et les analyses.",
      },
      irrigation_team: {
        changes: [
          "Page par défaut\u00a0:\u00a0Tâches",
          "Focus\u00a0: workflows d’arrosage et exécution opérationnelle",
        ],
        description:
          "Profil UX pour les utilisateurs qui travaillent principalement dans des flux de travail d’irrigation et d’exécution axés sur les tâches.",
      },
      research_partner: {
        changes: [
          "Page par défaut\u00a0: Science des données",
          "Focus\u00a0: exploration, données de capteurs et analyse",
        ],
        description:
          "Profil UX pour les utilisateurs qui travaillent principalement dans la science des données et l’analyse basée sur des capteurs.",
      },
      tree_inspector: {
        changes: [
          "Page par défaut : Cadastre des arbres",
          "Focus\u00a0: inspections, relevés d’arbres et travaux sur le terrain",
        ],
        description:
          "Profil UX pour les utilisateurs qui travaillent principalement dans le cadastre arboré et effectuent des inspections sur le terrain.",
      },
      treesense_support: {
        changes: [
          "Page par défaut\u00a0:\u00a0Capteurs",
          "Focus\u00a0: état des capteurs et flux de travail du support technique",
        ],
        description:
          "Profil UX pour les utilisateurs qui surveillent principalement les capteurs et gèrent les processus de support technique.",
      },
    },
    persona_footer:
      "Les personas façonnent le point d’entrée par défaut et l’accent UX. L'accès effectif provient toujours des autorisations du rôle backend.",
    persona_section_title: "Ce que cela change dans l'interface utilisateur",
    role: {
      admin: {
        changes: [
          "Peut gérer les flux de travail organisationnels sans propriété complète de la plateforme",
          "Dispose généralement d’un large accès au niveau client en fonction des autorisations backend",
        ],
        description:
          "Rôle administratif pour la gestion au niveau du client et les flux de travail organisationnels.",
      },
      basic: {
        changes: [
          "Travaille dans les projets et les zones assignés",
          "Les affectations de zones sont particulièrement pertinentes pour l’accès opérationnel",
        ],
        description:
          "Rôle d’utilisateur final opérationnel pour le travail quotidien dans les projets et les domaines assignés.",
      },
      superuser: {
        changes: [
          "Peut gérer les utilisateurs, les paramètres et l’administration au niveau du client",
          "A généralement l’accès le plus large à tous les modules",
        ],
        description:
          "Rôle administratif complet avec accès illimité aux zones de configuration et de gestion.",
      },
    },
    role_footer:
      "Les rôles déterminent les autorisations effectives. Les personas n'influencent que la navigation par défaut et la concentration UX.",
    role_section_title: "Ce que cela change dans l'accès",
  },
  show_all_trees: "Afficher tous les arbres",
  show_shortcuts: "Afficher les raccourcis",
  show_tree_list: "Afficher la liste des arbres",
  showing: "Affichage",
  showing_results: "Showing {{count}} results",
  signup: "S'inscrire",
  single_tree_view: "Vue arborescente unique",
  six_months: "6 mois",
  six_months_info: "Afficher les données des 6 derniers mois",
  size: "Taille",
  skip: "Sauter",
  soil: "Sol",
  soil_info: {
    heading: "Comprendre les paramètres du sol",
    intro: "Ces valeurs décrivent la capacité de rétention d’eau du sol à cet endroit :",
    items: {
      efc_help:
        "Quantité d’eau que les plantes peuvent réellement absorber (entre PWP et capacité sur le terrain).",
      efc_label: "Capacité en eau disponible (AWC) :",
      fc_help: "Quantité maximale d'eau que le sol peut retenir contre la gravité.",
      fc_label: "Capacité de terrain (FC) :",
      pwp_help:
        "Teneur en eau en dessous de laquelle les plantes ne peuvent plus extraire suffisamment d’eau et se flétrissent.",
      pwp_label: "Point de flétrissement permanent (PWP) :",
    },
    note: "Ces paramètres sont configurés par emplacement et influencent les recommandations d'irrigation.",
  },
  soil_moisture: "Humidité du sol",
  soil_moisture_edit: "Seuils vol. Humidité du sol",
  soil_moisture_sensor: "Capteur d'humidité du sol",
  soil_moisture_vg: "Humidité du sol (van Genuchten)",
  soil_name: "Nom du sol",
  soil_water_tension: "Tension de l'eau du sol",
  soil_water_tension_edit: "Seuils de tension hydrique du sol",
  soil_water_tension_sensor: "Capteur de tension de l'eau du sol",
  soil_water_tension_vg: "Tension de l'eau du sol (van Genuchten)",
  something_wrong: "Quelque chose s'est mal passé",
  species: "Espèces",
  start_scanning: "Démarrer la numérisation",
  start_typing_to_search: "Commencez à taper pour rechercher...",
  start_with_adding_new_project: "Commencez par ajouter un nouveau projet",
  state: "État",
  statistics: "Statistiques",
  stats_completed: "Complété",
  stats_in_progress: "En cours",
  stats_overdue: "En retard",
  stats_total: "Tâches totales",
  status: "Statut",
  status_BEAUFTRAGT: "Commandé",
  status_ERLEDIGT: "Complété",
  status_GEPLANT: "Prévu",
  status_IN_ARBEIT: "En cours",
  status_NICHT_GESCHAFFT: "Non terminé",
  status_completed: "Complété",
  status_in_progress: "En cours",
  status_planned: "Prévu",
  status_review: "En revue",
  stem_cane_removal: "Enlèvement de la canne à tige",
  stop_scanning: "Arrêter la numérisation",
  street_name: "Nom de la rue",
  structural_defects: "Défauts structurels",
  superuser: "Super utilisateur",
  table_column_preferences: "Colonnes visibles",
  table_column_preferences_hint:
    "Choisissez les colonnes à afficher dans les tableaux des arborescences, des capteurs et des tâches.",
  table_columns_sensors: "Capteurs",
  table_columns_trees: "Arbres",
  table_columns_tasks: "Tâches",
  task: "Tâche",
  task_assignee: "Cessionnaire",
  task_assignee_select_placeholder: "Sélectionnez le destinataire",
  task_attachments: "Pièces jointes",
  task_comments: "Commentaires",
  task_description: "Description",
  task_description_placeholder: "Entrez la description de la tâche",
  task_details: "Détails de la tâche",
  task_due_date: "Date d'échéance",
  task_filter_due_period: "Délai",
  task_filter_measure_type: "Type de tâche",
  task_filter_overdue: "En retard",
  task_filter_pruning_type: "Type de taille",
  task_filter_this_month: "Ce mois-ci",
  task_filter_this_week: "Cette semaine",
  task_filter_today: "Aujourd'hui",
  task_form: {
    assigned_to: "Attribué à",
    assignment: "Affectation",
    basic_info: "Informations de base",
    created_at: "Créé à",
    created_by: "Créé par",
    description: "Description",
    description_placeholder: "Entrez la description de la tâche",
    due_date: "Date d'échéance",
    priority: "Priorité",
    priority_high: "Haut",
    priority_low: "Faible",
    priority_medium: "Moyen",
    select_task_to_view: "Sélectionnez une tâche pour afficher les détails",
    select_user: "Sélectionnez un utilisateur",
    status: "Statut",
    status_completed: "Complété",
    status_in_progress: "En cours",
    status_pending: "En attente",
    title: "Titre",
    title_placeholder: "Entrez le titre de la tâche",
    tree: "Arbre",
  },
  task_location: "Emplacement",
  task_location_placeholder: "Entrez l'emplacement",
  task_priority: "Priorité",
  task_status: "Statut",
  task_type: "Type de tâche",
  task_plan: "Plan des tâches",
  completed_tasks: "Tâches terminées",
  planned_tasks: "Tâches planifiées",
  next_task: "Prochaine tâche",
  task_suggestion_bulk_create: "Créer la sélection",
  task_suggestion_bulk_created_success: "Suggestions sélectionnées créées.",
  task_suggestion_bulk_dismiss: "Ignorer la sélection",
  task_suggestion_bulk_dismissed_success: "Suggestions sélectionnées rejetées.",
  task_suggestion_bulk_manual_only:
    "En mode manuel, les suggestions d'irrigation ne peuvent être acceptées qu'une par une.",
  task_suggestion_choose_assignee_body:
    "Choisissez qui doit être affecté lorsque vous acceptez cette suggestion d’irrigation.",
  task_suggestion_choose_assignee_title: "Choisissez une personne responsable",
  task_suggestion_choose_assignee_validation: "Veuillez sélectionner une personne.",
  task_suggestion_create_task: "Créer une tâche",
  task_suggestion_created: "Créé",
  task_suggestion_created_success: "Tâche créée à partir d'une suggestion.",
  task_suggestion_dismiss: "Rejeter",
  task_suggestion_dismissed_success: "Suggestion rejetée.",
  task_suggestion_health_red: "Rouge",
  task_suggestion_health_yellow: "Jaune",
  task_suggestion_reason_fallback: "L’état de santé requiert une attention particulière.",
  task_suggestions_empty: "Aucune suggestion en attente.",
  task_suggestions_open_page: "Suggestions ouvertes",
  task_suggestions_pending_count: "suggestions en attente",
  task_suggestions_title: "Tâches suggérées",
  task_title: "Titre",
  task_title_placeholder: "Entrez le titre de la tâche",
  task_tree_info: "Informations sur l'arbre",
  task_tree_location: "Arbre et emplacement",
  task_tree_select: "Arbre",
  task_tree_select_placeholder: "Sélectionner un arbre",
  task_tree_species: "Espèces d'arbres",
  task_tree_species_placeholder: "Entrez les espèces d'arbres",
  tasks: "Tâches",
  tasks_completed_short: "complété",
  tasks_workflows: "Tâches et flux de travail",
  temperature: "Température",
  the: "le",
  theme: "Thème",
  theme_dark: "Sombre",
  theme_dark_desc: "Agréable pour les yeux",
  theme_description: "Choisissez à quoi ressemble TreeSense pour vous",
  theme_light: "Lumière",
  theme_light_desc: "Lumineux et clair",
  theme_system: "Système",
  theme_system_desc: "Suit votre appareil",
  three_weeks: "3 semaines",
  three_weeks_info: "Afficher les données des 3 dernières semaines",
  threshold: "Seuil",
  thresholds: "Seuils",
  thresholds_select_one_sensor: "Sélectionnez exactement un capteur pour afficher les seuils.",
  tick_the_checkbox_to_download_data: "Cochez la case pour télécharger les données",
  ticket_system: "Système de tickets",
  time: "Temps",
  time_range_info:
    "Sélectionnez une plage horaire pour afficher les données historiques. Choisissez parmi des plages prédéfinies ou définissez une période personnalisée.",
  time_range_selection: "Sélection de la plage horaire",
  timeframe: "Laps de temps",
  timeframe_hint:
    "Laissez tel quel pour télécharger les 30 derniers jours. Ajustez la plage pour affiner votre exportation.",
  to: "À",
  today: "Aujourd'hui",
  toggle_mobile_menu: "Basculer le menu mobile",
  toggle_project_sidebar: "Basculer la barre latérale du projet",
  tomorrow: "Demain",
  top_species: "Top 5 des espèces d’arbres",
  top_species_info_body:
    "Affiche les cinq espèces d'arbres les plus fréquentes dans votre sélection actuelle.",
  top_species_info_title: "Espèces d'arbres les plus courantes",
  topiary: "Art topiaire",
  total_sensors: "Nombre total de capteurs",
  total_trees: "Nombre total d'arbres",
  total_trees_species: "Nombre total d'espèces d'arbres",
  tour_start: "Démarrer la visite",
  traffic_safety_assessments: "Évaluations de la sécurité routière",
  traffic_safety_status: "Statut de sécurité routière",
  tree: "Arbre",
  treeNoSensor: "Arbre sans capteur",
  tree_added_successfully: "Arbre ajouté avec succès",
  tree_and_sensor: "Arbre et capteur",
  tree_cadastre: "Cadastre des arbres",
  tree_cadastre_no: "Cadastre des arbres Non",
  tree_control: "Contrôle des arbres",
  tree_count: "Nombre d'arbres",
  tree_form: {
    info: {
      represent: {
        heading: "Arbre représentatif",
        help: "Sélectionnez l'arborescence qui représente cet emplacement pour l'analyse et la création de rapports.",
        note: "Pour analyser les données le plus précisément possible, nous vous recommandons de télécharger en même temps une photo de l'arbre et une feuille représentative.",
      },
      sensors: {
        heading: "Capteurs",
        help: "Attribuez les capteurs qui appartiennent à cet arbre.",
        note: "Les capteurs sélectionnés permettent d'afficher des données en direct et de calculer des recommandations d'arrosage.",
      },
      soil: {
        heading: "Paramètres du sol",
        max_f_help: "Valeur maximale du capteur pour les arbres bien arrosés (F = irrigué).",
        max_f_label: "Max. valeur (arbres irrigués)",
        max_nf_help: "Valeur maximale du capteur pour les arbres non irrigués (NF = non irrigué).",
        max_nf_label: "Max. valeur (arbres non irrigués)",
        note: "Ces seuils permettent d'en déduire des recommandations d'arrosage et des couleurs de feux tricolores.",
        pwp_help:
          "Valeur du capteur à laquelle l'arbre atteint le point de flétrissement permanent (PWP).",
        pwp_label: "Point de flétrissement permanent (PWP)",
      },
    },
    more_info: "Plus d'informations",
    position: "Position",
    representTree: "Arbres enfants",
    sensors: "Capteurs",
    soil: "Sol",
    tree_profile: "Profil d'arbre",
  },
  tree_form_info: {
    add_title: "Ajouter un arbre",
    edit_title: "Modifier l'arborescence",
    more: {
      heading: "Plus d'informations",
      metrics_help:
        "Circonférence du tronc (cm), hauteur (m), diamètre de la couronne (m) — facultatif.",
      metrics_label: "Métrique:",
      note: "Utile pour les rapports et les recommandations ; peut être ajouté ultérieurement.",
      phase_help: "Choisissez Établissement, Développement ou Maintenance.",
      phase_label: "Phase:",
      species_help: "Effectuez une recherche en utilisant « nom latin | nom commun ».",
      species_label: "Espèces d'arbres :",
      year_help: "Sélectionnez l'année de plantation.",
      year_label: "Année de plantation :",
    },
    position: {
      altitude_help: "Facultatif. Laisser vide si inconnu.",
      altitude_label: "Altitude:",
      heading: "Position",
      latlng_help: "Requis. Entrez les coordonnées ou placez le marqueur sur la carte.",
      latlng_label: "Latitude/Longitude* :",
      map_help:
        "Utilisez les outils cartographiques pour zoomer, effectuer un panoramique et définir la position exacte.",
      map_label: "Carte:",
      note: "Des coordonnées précises améliorent les analyses et les cartes.",
    },
    profile: {
      cadastre_help: "Identifiant de registre facultatif (max 24 caractères).",
      cadastre_label: "Numéro de cadastre des arbres :",
      heading: "Profil d'arbre",
      name_help: "Nom lisible par l'homme (max 40 caractères).",
      name_label: "Nom:",
      note: "Vous pourrez les modifier ultérieurement dans les détails de l'arborescence.",
    },
    represent: {
      heading: "Arbre représentatif",
      help: "Déclarez éventuellement que cet arbre en représente d'autres (clustering).",
    },
    sensors: {
      heading: "Capteurs",
      help: "Attribuez des capteurs TreeSense existants à cet arbre ou supprimez des affectations.",
      note: "Les affectations des capteurs peuvent également être modifiées ultérieurement dans le détail de l'arborescence.",
    },
    soil: {
      heading: "Sol",
      max_f_help: "Valeur typique, par exemple 45.",
      max_f_label: "Capacité de terrain (max_f) :",
      max_nf_help: "Valeur typique, par exemple 25.",
      max_nf_label: "Max. eau disponible (max_nf) :",
      note: "Nécessaire uniquement si vous travaillez avec des estimations sol-eau.",
      pwp_help: "Point de flétrissement permanent (par exemple 10).",
      pwp_label: "PWP :",
    },
  },
  tree_health: "Santé des arbres",
  tree_info: "Informations sur l'arbre",
  tree_info_help: {
    description:
      "Cet onglet affiche les données principales de l’arbre sélectionné (espèces, dimensions, localisation et statut). Il fournit un contexte pour les lectures des capteurs et l’historique de maintenance.",
    fields: {
      dimensions_help:
        "Hauteur, diamètre de la couronne et circonférence du tronc tels que enregistrés en dernier lieu (valeurs d'inventaire).",
      dimensions_label: "Dimensions:",
      location_help:
        "Latitude/longitude WGS84 utilisée pour placer l'arbre sur la carte. La précision dépend des données d'inventaire sous-jacentes.",
      location_label: "Localisation/coordonnées :",
      species_help: "Nom scientifique (et nom commun si disponible).",
      species_label: "Espèces:",
      status_help:
        "Évaluation actuelle (par exemple pas de stress dû à la sécheresse / stress dû à la sécheresse). En fonction des paramètres du projet, cela peut être dérivé des données du capteur ou d'une évaluation manuelle.",
      status_label: "Statut de l'arbre :",
      year_phase_help:
        "Année de plantation (peut être estimée) et phase du cycle de vie telle que la phase d'établissement, de développement ou de vieillissement.",
      year_phase_label: "Année et phase de plantation :",
    },
    fields_heading: "Explications sur le terrain",
    heading: "Ce que vous voyez ici",
    note: "Astuce : Vous pouvez modifier les données de base via l'icône en forme de crayon si vous disposez des autorisations requises.",
  },
  tree_inventory: "Inventaire des arbres",
  tree_management_mode: "Mode de gestion des arbres",
  tree_name: "Nom de l'arbre",
  tree_phases: "Phases de l'arbre",
  tree_photos: "Arbre Photos",
  tree_profile: {
    learn_more: "Cliquez ici pour en savoir plus",
    tree_info: "Informations sur l'arbre",
    tree_species: "Faits intéressants",
    tree_species_knowledge: "Faits",
  },
  tree_species: "Espèces d'arbres",
  tree_stakes_control: "Contrôle des piquets d'arbres",
  tree_status: "Statut de l'arbre",
  tree_water_deficit: "Déficit hydrique des arbres",
  tree_water_stress: "Stress hydrique",
  tree_wiki: "Wiki Arbre",
  tree_with_sensor: "Arbre avec capteur",
  tree_without_sensor: "Arbre sans capteur",
  treegenus: "Genre d'arbre",
  trees: "Arbres",
  trees_short: "Arbres",
  trees_views: "Arbres",
  treespecies: "Espèces d'arbres",
  trunk_circumference: "Circonférence du tronc",
  trunk_defects: "Défauts du tronc",
  trunk_protection: "Protection du coffre",
  type: "Taper",
  type_an_adress: "Tapez une adresse",
  type_of_maintenance: "Type d'entretien",
  unable_to_upload_file: "Impossible de télécharger le fichier",
  unknown: "Inconnu",
  update: "Mise à jour",
  update_customer_logo_description: "Téléchargez et mettez à jour le logo de votre organisation",
  update_image: "Mettre à jour l'image",
  upload: "Télécharger",
  upload_3d_model: "Télécharger le modèle 3D",
  upload_file: "Télécharger le fichier",
  upload_leaf_img: "Télécharger l'image de la feuille",
  upload_tree: "Télécharger l'arborescence",
  upload_tree_img: "Télécharger l'image de l'arbre",
  use_my_location: "Utiliser ma position",
  use_new_moisture_formula: "Utiliser une nouvelle formule",
  user: "Utilisateur",
  user_details: {
    empty_project: "Utilisateur vide, veuillez commencer à ajouter des arbres.",
    no_user_selected: "Veuillez sélectionner un utilisateur pour afficher les détails",
  },
  user_form: {
    address: "Adresse",
    areas: "Zones d'irrigation",
    basic_info: "Informations de base",
    login_credentials: "Identifiants de connexion",
    profile: "Profil",
  },
  user_invitation_email_hint:
    "Après l'enregistrement, l'utilisateur recevra un e-mail pour définir son propre mot de passe.",
  username: "Nom d'utilisateur",
  users: "Utilisateurs",
  validation: {
    all_address_field_are_required: "Tous les champs d'adresse sont obligatoires",
    cadastre_or_name_required:
      "Le numéro de cadastre des arbres ou le nom de l’arbre doit être fourni.",
    either_field_required: "* Au moins un de ces champs est obligatoire.",
    email_is_required: "L'e-mail est requis",
    hardware_serial_is_required: "Le numéro de série du matériel est requis",
    hardware_serial_must_be_16_characters:
      "Le numéro de série du matériel doit comporter exactement 16 caractères.",
    imei_must_be_15_digits: "IMEI doit comporter exactement 15 chiffres.",
    invalid_email_address: "Adresse e-mail invalide",
    invalid_hex_identifier:
      "L’identifiant doit être une valeur hexadécimale majuscule valide. Veuillez utiliser uniquement les chiffres 0 à 9 et les lettres majuscules A à F.",
    invalid_house_number: "Numéro de maison invalide",
    must_be_a_number: "La valeur doit être un nombre",
    name_is_required: "Le nom est requis",
    out_of_range: "Value must be between {{min}} and {{max}}",
    password_is_required: "Le mot de passe est requis",
    position_is_required: "Le poste est requis",
    project_name_required: "Le nom du projet est requis",
    project_name_max_length: "Le nom du projet ne doit pas dépasser 100 caractères",
    project_start_required: "Le début du projet est requis",
    area_required: "La zone est requise",
    required_fields: "*Champs obligatoires",
    sensor_limit_exceeded_for_your_package: "Limite de capteur dépassée pour votre colis",
    task_error: "La tâche est requise.",
    tree_limit_exceeded_for_your_package: "Limite d'arbres dépassée pour votre forfait",
    user_limit_exceeded_for_your_package: "Limite d'utilisateurs dépassée pour votre forfait",
    user_with_this_email_already_exist: "Un utilisateur avec cette adresse e-mail existe déjà",
  },
  value: "Valeur",
  variables: "Variables",
  view_calendar: "Calendrier",
  view_kanban: "Kanban",
  view_list: "Liste",
  view_on_chart: "Ouvert en science des données",
  view_on_list: "Ouvrir dans la liste",
  view_on_map: "Ouvrir sur la carte",
  viewproject: "Voir le projet",
  views_per_page: "Vue par page",
  vitality_stage: "Étape de vitalité",
  vitality_stage_help: "0 = Vital, 1 = Légèrement affaibli, 2 = Affaibli, 3 = Gravement affaibli",
  vta_assessments: "Évaluations VTA",
  water_soil: "Humidité du sol",
  water_stress: "Stress hydrique",
  weather: "Météo",
  weekly_summary_email: "E-mail récapitulatif hebdomadaire",
  welcome_back: "Content de te revoir!",
  wiki_help: "Wikis et guides",
  with_sensor: "Avec capteur",
  without_location: "Sans localisation",
  without_project: "Sans projet",
  without_sensor: "Sans capteur",
  working: "Fonctionnement",
  write_some_notes_on_action_performed: "Écrivez quelques notes sur l'action effectuée...",
  write_something: "Écrivez quelque chose...",
  years_short: "années",
  zip_code: "Code postal",
  zoom_in: "Zoomer",

  // NB-IoT sensor configuration
  weekly_signal_avg: "Intensité du signal (moy. 7j)",
  signal_strength: "Signal",
  signal_low: "Faible",
  signal_medium: "Moyen",
  signal_high: "Fort",
  signal_strength_info:
    "L'intensité du signal affecte l'autonomie de la batterie. Un signal faible consomme le plus de batterie, un signal moyen consomme plus qu'un signal fort, et un signal fort est le plus efficace.",
  signal_no_data: "Aucune donnée",
  send_interval: "Intervalle d'envoi",
  measurement_interval: "Intervalle de mesure",
  send_configuration: "Envoyer la configuration",
  downlink_queued: "Configuration mise en file d'attente pour le prochain uplink",
  downlink_failed: "Échec de la mise en file d'attente de la configuration",
  confirm_send_downlink: "Êtes-vous sûr de vouloir envoyer la configuration au capteur ?",
  no_intervals_configured: "Aucun intervalle configuré",
  interval_5min: "5 minutes",
  interval_10min: "10 minutes",
  interval_15min: "15 minutes",
  interval_30min: "30 minutes",
  interval_1h: "1 heure",
  interval_2h: "2 heures",
  interval_4h: "4 heures",
  interval_6h: "6 heures",
  interval_12h: "12 heures",
  interval_24h: "24 heures",

  // Irrigation Export
  irrigation_export_title: "Exporter le plan d'irrigation",
  irrigation_export_button: "Exporter",
  yes: "Oui",
};
